<template>
  <LoginHolder>
    <h2 class="mb-1">Resend Confirmation Token</h2>
    <p class="pb-3">A new token will be sent to the registered email.</p>
    <AlertMessage :alerMessage="alerMessage"></AlertMessage>
    <ValidationObserver ref="observer">
      <form
        ma-8
        v-on:submit.prevent>
        <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required">
          <v-text-field
            v-model="user.email"
            maxlength="100"
            :error-messages="errors"
            label="Enter your email address"
            required
          ></v-text-field>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <v-btn
      depressed
      block
      rounded
      large
      color="primary mb-8 mt-6"
      @click="send()"
    >
      Resend Token
    </v-btn>

    <v-btn
      depressed
      block
      rounded
      large
      :to="{ name: 'login' }"
    >
      Login
    </v-btn>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  export default {
    name: 'ResendConfirmationToken',
    data: () => ({
      passShow: false,
      user: {
        email: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false
    }),
    computed: {

    },
    methods: {
      async send(){
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this

        this.$http.secured.post('/users/resend-registration-confirmation-token', this.user)
          .then(response => {
            this.$router.push({ name: 'confirm-registration', query: { email: this.user.email } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
    },
    mounted() {
    },
    components: {
      SnackBar,
      ValidationProvider,
      ValidationObserver,
      LoginHolder,
      AlertMessage
    },
  }
</script>
